<lib-survey-layout>
  <lib-survey
    (surveyLoad)="onSurveyLoad()"
    (pageChanged)="(undefined)"
    (submitted)="onSubmit()"
  >
  </lib-survey>
</lib-survey-layout>
